import { ShiftManagementTemplatesDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { usePaginatedQuery } from 'modules/core/hooks/usePaginatedQuery'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { usePageStatus } from 'modules/layout/components/ResponsivePage/FactorialOnePage/usePageStatus'
import ShiftTemplatesSettings from 'modules/shift_management/components/Settings/ShiftTemplates'

const ShiftTemplatesPage = () => {
  const { debouncedSearch, search, onSearch } = useDebouncedSearch()

  const { nodes, loading, controls } = usePaginatedQuery(ShiftManagementTemplatesDocument, {
    variables: { includeArchived: false, searchByName: debouncedSearch },
    extractConnection: (data) => data?.shiftManagement.templatesConnection,
  })
  const shiftTemplates = nodes || []

  const { clearPageStatus } = usePageStatus()
  clearPageStatus()

  return (
    <ResponsivePage.Body showHeader>
      <ShiftTemplatesSettings
        shiftTemplates={shiftTemplates}
        controls={controls}
        search={search}
        loading={loading}
        onSearch={onSearch}
      />
    </ResponsivePage.Body>
  )
}

export default observer(ShiftTemplatesPage)
